export const subscriptionGroups = {
  SUBSCRIPTION_GROUPS: '/v2/items/subscription-groups',
  SUBSCRIPTION_GROUP_ITEM: '/v2/items/subscription-groups/{subscription_group_uuid}/access-fees',
  DELETE_SUBSCRIPTION_GROUP: '/v2/items/subscription-groups/{subscription_group_uuid}',
  DELETE_SUBSCRIPTION_GROUP_ITEM: '/v2/items/subscription-groups/{subscription_group_uuid}/access-fees/{access_fee_id}',
  EDIT_SUBSCRIPTION_GROUP: '/v2/items/subscription-groups/{subscription_group_uuid}',
};
